// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as JsxRuntime from "react/jsx-runtime";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CommonCardFieldHooks$OrcaPaymentPage from "./CommonCardFieldHooks.bs.js";

function SecureCardCvcField(props) {
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let savedCardBrand = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.savedCardBrand);
  let state = CommonCardFieldHooks$OrcaPaymentPage.useCardCvcField(loggerState, savedCardBrand, true, undefined);
  return JsxRuntime.jsx(CommonCardFieldHooks$OrcaPaymentPage.RenderCardCvc.make, {
    state: state
  });
}

let make = SecureCardCvcField;

export {
  make,
}
/* jotai Not a pure module */
